// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610200911/js/" + chunkId + "." + {"44":"b5523227","225":"9bc139c2","481":"cea8e364","486":"da0ba249","770":"f3da7821"}[chunkId] + ".0.18435968597429864.chunk.js";
};